const PRODUCTION_URL =
  'https://script.google.com/macros/s/AKfycbw2vnydjn5zFXf1mIZlN9KWN8CZt4jwALL12ngaP35U0UzMPeYAxRIn5imFwQ4Y4BoK/exec';
const DEVELOPMENT_URL =
  'https://script.google.com/macros/s/AKfycbwI-dEVd8iXTbsiSAJSd8ycYqhNe1cwZBq-8Qez3wEPvKpDD-1WTZK4iMR2PmjTe9O3/exec';

const url = process.env.REACT_APP_CLIENT_ENVIRONMENT === 'production' ? PRODUCTION_URL : DEVELOPMENT_URL;

interface IPostSellTractorSurveyDataToSpreadSheet {
  userId: string;
  userName: string;
  userPhoneNumber: string;
  completed: boolean;
}

export const postSellTractorSurveyDataToSpreadSheet = ({
  userId,
  userName,
  userPhoneNumber,
  completed,
}: IPostSellTractorSurveyDataToSpreadSheet) => {
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      userId,
      userName,
      userPhoneNumber,
      completed,
      path: 'saveUserSellTractorDraft',
    }),
  });
};
